import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=4b6f5035&scoped=true"
import script from "./CurrencySelector.vue?vue&type=script&lang=js"
export * from "./CurrencySelector.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelector.vue?vue&type=style&index=0&id=4b6f5035&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f5035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6f5035')) {
      api.createRecord('4b6f5035', component.options)
    } else {
      api.reload('4b6f5035', component.options)
    }
    module.hot.accept("./CurrencySelector.vue?vue&type=template&id=4b6f5035&scoped=true", function () {
      api.rerender('4b6f5035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/apps/header/components/CurrencySelector.vue"
export default component.exports